import { CheckIcon } from 'lucide-react'
import { useEffect, useRef, useState } from 'react'

import { cn } from '@/shared/lib'
import { AnimatedIcon } from '@/shared/ui/animated-icon'
import { IconButton } from '@/shared/ui/icon-button'
import { CopyIcon } from '@/shared/ui/icons/copy'

const CONFIRM_MS = 1500

type CopyButtonProps = {
  value: string
  /** Accessible name — «Скопировать адрес», not the value itself. */
  label: string
  size?: 'xs' | 'sm'
  className?: string
}

/**
 * Clipboard copy for identifiers — wallet addresses, tx hashes, IPs. The
 * confirmation is the icon itself flipping to a check; no toast, because the
 * feedback belongs where the click happened.
 */
export function CopyButton({ value, label, size = 'xs', className }: CopyButtonProps) {
  const [isCopied, setIsCopied] = useState(false)
  const timer = useRef<ReturnType<typeof setTimeout>>(undefined)

  useEffect(() => () => clearTimeout(timer.current), [])

  const handleCopy = () => {
    void navigator.clipboard.writeText(value).then(() => {
      setIsCopied(true)
      clearTimeout(timer.current)
      timer.current = setTimeout(() => setIsCopied(false), CONFIRM_MS)
    })
  }

  return (
    <IconButton
      size={size}
      variant="ghost"
      label={label}
      onClick={handleCopy}
      className={cn('shrink-0', className)}
    >
      {isCopied ? <CheckIcon className="text-primary" /> : <AnimatedIcon icon={CopyIcon} />}
    </IconButton>
  )
}
